import { Heart, Youtube, Users, Quote } from "lucide-react";

export const SocialProofSection = () => {
  const testimonials = [
    {
      text: "New Coupling 덕분에 10년 만에 다시 사랑을 시작했어요. 지금은 행복한 연인이 생겼습니다.",
      name: "김OO",
      location: "미국 LA",
    },
    {
      text: "해외에서 혼자 지내다 보니 외로웠는데, 줌미팅으로 같은 처지의 분들을 만나니 정말 위안이 됐어요.",
      name: "이OO", 
      location: "캐나다",
    },
    {
      text: "연애사관학교 프로그램이 정말 도움이 많이 됐습니다. 자존감도 회복하고 새로운 인연도 만났어요!",
      name: "박OO",
      location: "호주",
    },
  ];

  return (
    <section
      id="social-proof"
      className="py-10 lg:py-14 bg-[#e8e4e1]"
      data-testid="social-proof-section"
    >
      <div className="max-w-6xl mx-auto px-6">
        {/* Section Title */}
        <div className="text-center mb-8">
          <span className="text-gold-500 font-medium text-sm tracking-wider uppercase mb-4 block">
            Social Proof
          </span>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
          <div className="text-center p-8 bg-white/50 rounded-2xl">
            <div className="w-16 h-16 mx-auto mb-4 bg-burgundy-50 rounded-full flex items-center justify-center">
              <Heart className="w-8 h-8 text-burgundy-500" />
            </div>
            <div className="font-sans text-4xl md:text-5xl font-[720] text-burgundy-500 mb-2">
              200+
            </div>
            <p className="text-stone-600 text-lg">쌍 이상의 커플 탄생</p>
          </div>

          <div className="text-center p-8 bg-white/50 rounded-2xl">
            <div className="w-16 h-16 mx-auto mb-4 bg-red-50 rounded-full flex items-center justify-center">
              <Youtube className="w-8 h-8 text-red-500" />
            </div>
            <div className="font-sans text-4xl md:text-5xl font-[720] text-burgundy-500 mb-2">
              30만+
            </div>
            <p className="text-stone-600 text-lg">유튜브 구독자</p>
          </div>

          <div className="text-center p-8 bg-white/50 rounded-2xl">
            <div className="w-16 h-16 mx-auto mb-4 bg-gold-50 rounded-full flex items-center justify-center">
              <Users className="w-8 h-8 text-gold-500" />
            </div>
            <div className="font-sans text-4xl md:text-5xl font-[720] text-burgundy-500 mb-2">
              1000+
            </div>
            <p className="text-stone-600 text-lg">커뮤니티 회원 활동</p>
          </div>
        </div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 shadow-sm relative"
              data-testid={`testimonial-${index}`}
            >
              <Quote className="w-8 h-8 text-gold-300 mb-4" />
              <p className="text-stone-700 text-sm leading-relaxed mb-4">
                "{testimonial.text}"
              </p>
              <div className="text-stone-500 text-sm">
                <span className="font-medium text-stone-700">{testimonial.name}</span>
                <span className="mx-2">·</span>
                <span>{testimonial.location}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
